<script>
  import { tweened } from "svelte/motion";
  import mq from "../stores/mq.js"; // here, defined laptop = 992px

  export let progress = 0;
  export let zoomStart;
  export let zoomEnd;

  $: currentZoom = {
    scale: tweenThis(zoomStart.scale, zoomEnd.scale, progress),
    top: tweenThis(zoomStart.top, zoomEnd.top, progress, true), // (this position refers to the position of the zoom, not the transform)
    left: tweenThis(zoomStart.left, zoomEnd.left, progress, true)
  };

  function tweenThis(oldVal, newVal, progress, percentage = false) {
    const calcTween = function (a, b, progress) {
      return progress < 0.8 ? a + ((b - a) * progress) / 0.8 : b;
    };
    if (percentage) {
      return calcTween(parseFloat(oldVal), parseFloat(newVal), progress) + "%";
    } else {
      return calcTween(oldVal, newVal, progress);
    }
  }
</script>

<div class="zoom-pan-wrapper {$mq.classNames}">
  <div
    class="transform-div"
    style="
    transform: 
    translate3d({currentZoom ? '-' + currentZoom.left : '0%'}, {currentZoom ? '-' + currentZoom.top : '0%'},0)
    scale({currentZoom ? currentZoom.scale : 1});
  "
  >
    <slot />
  </div>
</div>

<style>
  .zoom-pan-wrapper {
    /* transition: transform 1s ease-in; */
    height: 100%;
    width: 100%;
    /* Safari doesn't support overflow-clip*/
    overflow: hidden; 
  }
  @supports (overflow: clip){
    .zoom-pan-wrapper {
      overflow-y: clip;
      overflow-x: visible;
    }
  }

  .mq-mobile.zoom-pan-wrapper {
    overflow: hidden;
  }
  .transform-div {
    transform-origin: top left;
  }
</style>
